module.exports = __webpack_public_path__ + "img/excel.e04c0c04.png";